import { useDeviceDashBoard } from "../../Hooks/Features/HelpDesk/useDeviceDashBoard"
import { dateConvert } from "../../utils/Helper";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { useCommon } from "../../Hooks/Common/useCommon";
import { MultiSelect } from "primereact/multiselect";
import DatePicker from "react-multi-date-picker";
import { AgGridReact } from "@ag-grid-community/react";
import { SkeletonDataTable } from "../Loader/Loader";
import PanelHeaderTemplate from "../CommonCompo/PanelHeadeTemplate/PanelHeaderTemplate";
import { useTheme } from "../../context/ThemeContext";

const DeviceDashboard = () => {

    const { deviceData, handleAssignreceive, showPopup, setShowPopup, selectedData, setSelectedData, users, tagRef, historyPopup, setHistoryPopup, getDeviceHistory, popupFilters, setPopupFilters, deviceOpts, rowData, columnDefs, loader, isChange, setIsChange, userData } = useDeviceDashBoard();
    const { checkPermission } = useCommon();
    const { theme } = useTheme();

    const getStatusClass = (status) => {
        switch (status?.toLowerCase()) {
            case 'available':
                return 'available';
            case 'hold':
                return 'hold';
            case 'expired':
                return 'expired';
            case 'issued':
                return 'issued';
            default:
                return 'other';
        }
    }

    return (
        <div ref={() => checkPermission("inventory", tagRef)}>
            <div ref={tagRef} id='{"tabname": "inventory", "data": "device_dashboard_tab"}'>
                <section className="mb-5">
                    <div className="d-flex justify-content-between align-items-end mb-3">
                        <h2 className="fs-6 fw-semibold text-danger">📦 Assigned Devices</h2>
                        <button type="button" className="sk-btn sk-btn-primary" onClick={() => { setHistoryPopup(true); setPopupFilters((prev) => ({ ...prev, device: [], users: [] })) }}>
                            <i className="icon-history-outline" /> History
                        </button>
                    </div>
                    <div className="row g-3">
                        {
                            deviceData?.unavailable?.length > 0 ?
                                deviceData?.unavailable?.map((item, index) => {
                                    return <div className="col-6 col-sm-4 col-md-3" key={index}>
                                        <div className={`sk-card-container ${theme}`}>
                                            <div className="sk-card-header">
                                                <div>
                                                    <div className="sk-card-name">{item?.device_name}</div>
                                                    <div className="sk-card-sub-text">SKU: {item?.device_sku_id}</div>
                                                </div>
                                                <button title="Receive" className="sk-btn sk-btn-primary" onClick={() => { setShowPopup(true); setSelectedData((prev) => ({ ...prev, data: item, type: "R" })) }}>
                                                    <i className="icon-revoke-outline" />
                                                </button>
                                            </div>
                                            <div className="sk-card-status">
                                                <span className={`sk-card-tag ${getStatusClass("issued")}`}>Issued</span> to {item?.user_display_name} on {dateConvert(item?.issued_datetime, "date-time-month")}
                                            </div>
                                        </div>
                                    </div>
                                }) : <div className='text-center'>
                                    <img src={"./assets/nodata.jpg"} alt='no data' style={{ height: "50%" }} />
                                    <p className='text-center red mt-3'> Data Not Found</p>
                                </div>
                        }
                    </div>
                </section>
                <section>
                    <h2 className="fs-6 fw-semibold text-success mb-3">✅ Available Devices</h2>
                    <div className="row g-3">
                        {
                            deviceData?.available?.length > 0 ?
                                deviceData?.available?.map((item, index) => {
                                    return <div className="col-6 col-sm-4 col-md-3" key={index}>
                                        <div className={`sk-card-container ${theme}`}>
                                            <div className="sk-card-header">
                                                <div>
                                                    <div className="sk-card-name">{item?.device_name}</div>
                                                    <div className="sk-card-sub-text">SKU: {item?.device_sku_id}</div>
                                                </div>
                                                <button title="Assign" className="sk-btn sk-btn-primary" onClick={() => { setShowPopup(true); setSelectedData((prev) => ({ ...prev, data: item, type: "I" })) }}>
                                                    <i className="icon-approve-outline" />
                                                </button>
                                            </div>
                                            <div className="sk-card-status">
                                                <span className={`sk-card-tag ${getStatusClass("available")}`}>Available</span>
                                            </div>
                                        </div>
                                    </div>
                                }) : <div className='text-center'>
                                    <img src={"./assets/nodata.jpg"} alt='no data' style={{ height: "50%" }} />
                                    <p className='text-center red mt-3'> Data Not Found</p>
                                </div>
                        }
                    </div>
                </section>
                <Dialog visible={showPopup} modal onHide={() => setShowPopup(false)} className='modal-xsmall' draggable={false} header={() => selectedData?.type === "I" && <div>Assign Device</div>}>
                    <div className='row'>
                        <div className='my-3'>
                            {
                                selectedData?.type === "R" ?
                                    <>
                                        <h5 className='text-center'>Are you sure you have received {selectedData?.data?.device_name} device from {selectedData?.data?.user_display_name} ?</h5>
                                        <div className='w-100 d-flex justify-content-center gap-2 mt-4'>
                                            <button className='btn-primary' label="Close" onClick={handleAssignreceive} >Yes</button>
                                            <button className='btn-default' label="Close" onClick={() => setShowPopup(false)} >No</button>
                                        </div>
                                    </>
                                    : <div>
                                        <label>Select User</label>
                                        <div className="d-flex align-self-center">
                                            <Dropdown value={selectedData?.user} onChange={(e) => setSelectedData((prev) => ({ ...prev, user: e.value }))} placeholder="Select User" options={users} optionLabel="label" className="input-dd mb-0"
                                                filter filterInputAutoFocus disabled={!(userData?.user_category_key === 'service-desk' || userData?.user_category_key === 'it-support')} />
                                            <button className='btn-primary' label="Close" onClick={handleAssignreceive} >Assign</button>
                                        </div>
                                    </div>
                            }
                        </div>
                    </div>
                </Dialog>

                <Dialog visible={historyPopup} onHide={() => setHistoryPopup(false)} draggable={false} header="Device Assignment History" className="modal-medium" style={{ maxWidth: "55vw" }}>
                    <div>
                        <div className="d-flex gap-2">
                            <div className="w30">
                                <MultiSelect placeholder="Device Name" options={deviceOpts} optionLabel="label" value={popupFilters?.device} onChange={(e) => { setPopupFilters((prev) => ({ ...prev, device: e.target.value })); setIsChange(true); }} onHide={() => { if (isChange) { getDeviceHistory(); setIsChange(false); } }} filter filterInputAutoFocus panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'device', popupFilters?.device, () => setPopupFilters((prev) => ({ ...prev, device: [] })), () => { getDeviceHistory(true, false) })}
                                />
                            </div>
                            <div className="w30">
                                <MultiSelect placeholder="Assigned to" options={users} optionLabel="label" value={popupFilters?.users} onChange={(e) => { setPopupFilters((prev) => ({ ...prev, users: e.target.value })); setIsChange(true); }} onHide={() => { if (isChange) { getDeviceHistory(); setIsChange(false) } }} filter filterInputAutoFocus panelHeaderTemplate={(options) => PanelHeaderTemplate(options, 'users', popupFilters?.users, () => setPopupFilters((prev) => ({ ...prev, users: [] })), () => { getDeviceHistory(false, true) })} />
                            </div>
                            <div className="w40">
                                <DatePicker portal zIndex={99999} placeholder="Select Date Range" value={popupFilters?.hoveredRange} onChange={(e) => {
                                            if (!e || e.length === 2) {
                                                setPopupFilters((prev) => ({ ...prev, hoveredRange: e }));
                                            }
                                        }} range rangeHover />
                            </div>
                        </div>
                        <div style={{ height: "50vh" }} className="ag-theme-alpine mt-2">
                            {loader ? <div><SkeletonDataTable numSkeletons={12} /></div> :
                                <AgGridReact rowData={rowData} columnDefs={columnDefs} headerHeight={30} rowHeight={30} />
                            }
                        </div>
                    </div>
                </Dialog>
            </div>
        </div>
    )
}

export default DeviceDashboard
